import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import {
  Button,
  Form,
  Input,
  Modal,
  Popconfirm,
  Segmented,
  message,
} from "antd";
import {
  PlusOutlined,
  SettingOutlined,
  RightOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { FilterOutlined } from "@ant-design/icons";
import fitericon from "../Assets/calender/action-filter-outline.png";
import "../App.css";
import FilterModal from "./CalenderModal/FilterModal"; // Import Filter Modal
import { URL } from "../helper/Mainurl";
import AddTask from "./CalenderModal/AddTask";
import ViewTask from "./CalenderModal/ViewTask";
import "./Calender.css";
import ViewEvent from "./CalenderModal/ViewEvent";
import { useLocation } from "react-router-dom";
import { formatEvents } from "../helper/formatEvents";
import { apiClient } from "../utils/apiClient";

let lastClickTime = 0;

const Calender = () => {
  const token = localStorage.getItem("authToken"); // Get token from localStorage
  const location = useLocation();
  const [emailForm] = Form.useForm();
  const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false);
  const [progressStatus, setProgressStatus] = useState({});
  const [colorMetaData, setColorMetaData] = useState([]);
  const [calendarView, setCalendarView] = useState("timeGridWeek");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState([]);
  const [ViewTaskmodalOpen, setViewTaskmodalOpen] = useState(false);
  const [ViewEventmodalOpen, setViewEventmodalOpen] = useState(false);
  const [calendarMetaData, setCalendarMetaData] = useState([]);
  const [isConfirmOpen, setIsConfimOpen] = useState(false);
  const [isPopconfirmOpen, setIsPopconfirmOpen] = useState(false);
  const [events, setEvents] = useState([]); // ✅ Store API events
  const [submitLoading, setSubmitLoading] = useState(false);
  const [preselectedDate, setPreselectedDate] = useState(null);

  const today = new Date();
  const initialStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const initialEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [startDate, setStartDate] = useState(
    moment(initialStartDate).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(initialEndDate).format("YYYY-MM-DD")
  );
  const [calendarApi, setCalendarApi] = useState(null);
  const calendarRef = useRef(null);
  const [calendarTitle, setCalendarTitle] = useState("");
  const [filters, setFilters] = useState({
    category: null,
    priorities: [],
    status: null,
    colors: [],
    selectedUsers: [],
  });
  const [setsegmentState, setSetsegmentState] = useState("Week"); // for splicing the event title
  // Function to handle filter application

  const applyFilters = async (priorityId, progressId, type, colorId) => {
    let baseUrl = `${URL}/v1/calendar/calendar-data`;

    // Build params object
    const params = new URLSearchParams();

    // Only append if value exists and is not empty
    const addParam = (key, value) => {
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        if (Array.isArray(value)) {
          value.forEach((v) => params.append(`${key}[]`, v));
        } else {
          params.append(key, value);
        }
      }
    };

    addParam("priority_id", priorityId);
    addParam("progress_status_id", progressId);
    addParam("start_date", startDate);
    addParam("end_date", endDate);
    addParam("type", type);
    if (colorId) {
      addParam("color_id", [colorId]);
    }

    const finalUrl = `${baseUrl}?${params.toString()}`;

    console.log("finalUrl", finalUrl);

    const res = await fetch(finalUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();
    if (data.code === 200) {
      const formattedEvents = formatEvents(data.data);
      setEvents(formattedEvents);
    }

    setIsFilterModalOpen(false);
  };

  const getCalenderData = async (
    startDate,
    endDate,
    category,
    status,
    priorities
  ) => {
    try {
      const response = await apiClient.get("/v1/calendar/calendar-data", {
        start_date: startDate,
        end_date: endDate,
        ...(category && { type: category }),
        ...(status && { progress_status_id: status }),
        ...(priorities && { priority_id: priorities }),
      });

      const data = response.data;

      if (data?.code === 200 && (!data.data || data.data.length === 0)) {
        if (category || status || priorities) {
          message.error(`No calendar data found for the selected filters.`);
        } else {
          // message.error("No calendar data available for this date.");
        }
        setEvents([]); // Clear events
        return;
      }

      if (data?.code === 200 && Array.isArray(data?.data)) {
        // console.log("data.data",data.data)
        const formattedEvents = data.data.map((event) => ({
          id: crypto.randomUUID(), // Unique fallback ID require for calendar
          ...(event.type === "event" && { event_id: event.id }),
          ...(event.type === "task" && { task_id: event.id }),
          task_master_id: event?.task_master_id || null,
          event_master_id: event?.event_master_id || null,
          title: event?.title || "Untitled Event",
          assigned_by: event?.assigned_by,
          location: event?.location,
          description: event?.description,
          start: event?.start_time
            ? moment.utc(event.start_time).format("YYYY-MM-DDTHH:mm:ss")
            : null,
          occurrenceDate: moment.utc(event.start_time).format("YYYY-MM-DD"),
          end: event?.end_time
            ? moment.utc(event.end_time).format("YYYY-MM-DDTHH:mm:ss")
            : null,
          reminder: event?.reminder_timestamp || null,
          createdBy: event?.created_by,
          updatedBy: event?.updated_by,
          type: event?.type,
          displaynameId: event?.display_name_id,
          priorityId: event?.priority_id || null,
          progressStatusId: event?.progress_status_id || null,
          assigned_by: event?.assigned_by,
          checklists: Array.isArray(event?.checklists) ? event.checklists : [],
          color_id: Number(event?.color_id ?? null), // Default color
          assignees: event?.assignees || [],
          collaborators: event?.collaborators || [],
          repeat_option: event?.repeat_option,
          repetition_end_date: event?.repetition_end_date,
          exclude_saturdays: event?.exclude_saturdays,
          exclude_sundays: event?.exclude_sundays,
          include_weekends: event?.include_weekends,
          included_weekend_days: event?.included_weekend_days,
          adjust_weekends: event?.adjust_weekends,
        }));
        // console.log("formattedEvents>>", formattedEvents)
        setEvents(formattedEvents);

        if (category || status || priorities) {
          message.success("Calendar filter applied successfully.");
        } // isFilterModalOpen(true)
      } else {
        // message.error("Error fetching calendar data");
      }
    } catch (error) {
      console.error("Fetch request failed:", error);
    }
  };

  useEffect(() => {
    // if (startDate && endDate && category || status || priorities){
    //   getCalenderData(startDate, endDate,category,status,priorities);

    // }
    let start = moment(initialStartDate).format("YYYY-MM-DD");
    let end = moment(initialEndDate).format("YYYY-MM-DD");
    if (startDate && endDate) {
      getCalenderData(startDate, endDate);
    } else {
      getCalenderData(start, end);
    }
  }, [startDate, endDate]);

  const datesSetHandler = (info) => {
    setCalendarView(info.view.type);

    if (info.view.type === "dayGridMonth") {
      // Always use the first and last day of the *current* month, not the grid
      const currentMonthDate = info.view.currentStart;
      const year = currentMonthDate.getFullYear();
      const month = currentMonthDate.getMonth(); // 0-based
      const start = new Date(year, month, 1);
      const end = new Date(year, month + 1, 0); // last day of month
      const startStr = moment(start).format("YYYY-MM-DD");
      const endStr = moment(end).format("YYYY-MM-DD");
      // console.log("datesSetHandler", {startStr, endStr})
      setStartDate(startStr);
      setEndDate(endStr);
    } else {
      // For week/day views, use the visible range, but FullCalendar's end is exclusive
      const startStr = moment(info.start).format("YYYY-MM-DD");
      const endStr = moment(info.end).subtract(1, "days").format("YYYY-MM-DD");
      setStartDate(startStr);
      setEndDate(endStr);
    }

    const formattedTitle = info.view.title.replace(
      /(\w+) (\d+), (\d+)/,
      "$2 $1, $3"
    );
    setCalendarTitle(formattedTitle);
  };
  const handleTaskClick = (info) => {
    console.log("handleTaskClick", info.event.extendedProps);
    const eventData = {
      id: info.event.id,
      title: info.event.title,
      location: info.event.extendedProps.location,
      ...(info.event.extendedProps.type === "event" && {
        event_id: info.event.extendedProps.event_id,
      }),
      ...(info.event.extendedProps.type === "task" && {
        task_id: info.event.extendedProps.task_id,
      }),
      task_master_id: info.event.extendedProps.task_master_id,
      description: info.event.extendedProps.description,
      start: info.event.start,
      end: info.event.end,
      occurrenceDate: info.event.extendedProps.occurrenceDate,
      displaynameId: info.event.extendedProps.displaynameId,
      reminder: info.event.extendedProps.reminder,
      createdBy: info.event.extendedProps.createdBy,
      updatedBy: info.event.extendedProps.updatedBy,
      type: info.event.extendedProps.type,
      priorityId: info.event.extendedProps.priorityId,
      progressStatusId: info.event.extendedProps.progressStatusId,
      assigned_by: info.event.extendedProps.assigned_by,
      checklists: info.event.extendedProps.checklists || [],
      color_id: info.event.extendedProps.color_id,
      assignees: info.event.extendedProps.collaborators,
      collaborators: info.event.extendedProps.collaborators,
      repeat_option: info.event.extendedProps.repeat_option,
      repetition_end_date: info.event.extendedProps.repetition_end_date,
      exclude_saturdays: info.event.extendedProps?.exclude_saturdays,
      exclude_sundays: info.event.extendedProps?.exclude_sundays,
      include_weekends: info.event.extendedProps?.include_weekends,
      included_weekend_days: info.event.extendedProps?.included_weekend_days,
      adjust_weekends: info.event.extendedProps?.adjust_weekends,
    };

    setSelectedEvent(eventData);
    setViewTaskmodalOpen(true);
    // console.log("eventDataNew:::::::::", selectedEvent)
    // console.log("eventDataNew_________handleTaskClick", eventData)
  };
  const handleEventClick = (info) => {
    // console.log("eventDataNew_________handleEventClick", info.event.extendedProps)
    const eventData = {
      id: info.event.id,
      event_master_id: info.event.extendedProps.event_master_id,
      ...(info.event.extendedProps.type === "event" && {
        event_id: info.event.extendedProps.event_id,
      }),
      // ...(info.event.extendedProps.type === "task" && { task_id: info.event.extendedProps.task_id }),
      title: info.event.title,
      location: info.event.extendedProps.location,
      description: info.event.extendedProps.description,
      start: info.event.start,
      end: info.event.end,
      displaynameId: info.event.extendedProps.displaynameId,
      reminder: info.event.extendedProps.reminder,
      createdBy: info.event.extendedProps.createdBy,
      updatedBy: info.event.extendedProps.updatedBy,
      type: info.event.extendedProps.type,
      occurrenceDate: info.event.extendedProps.occurrenceDate,
      priorityId: info.event.extendedProps.priorityId,
      progressStatusId: info.event.extendedProps.progressStatusId,
      assigned_by: info.event.extendedProps.assigned_by,
      checklists: info.event.extendedProps.checklists || [],
      color_id: info.event.extendedProps.color_id,
      assignees: info.event.extendedProps.collaborators,
      collaborators: info.event.extendedProps.collaborators,
      repeat_option: info.event.extendedProps.repeat_option,
      repetition_end_date: info.event.extendedProps.repetition_end_date,
      exclude_saturdays: info.event.extendedProps?.exclude_saturdays,
      exclude_sundays: info.event.extendedProps?.exclude_sundays,
      include_weekends: info.event.extendedProps?.include_weekends,
      included_weekend_days: info.event.extendedProps?.included_weekend_days,
      adjust_weekends: info.event.extendedProps?.adjust_weekends,
    };

    setSelectedEvent(eventData);
    setViewEventmodalOpen(true);
  };

  // const handleViewChange = (value) => {
  //   setSetsegmentState(value);
  //   let newView = "";
  //   let startDate = "";
  //   let endDate = "";

  //   const today = new Date();

  //   const formatDate = (date) => {
  //     // return date.toISOString().split("T")[0]; // YYYY-MM-DD
  //     return moment(date).format("YYYY-MM-DD");
  //   };

  //   if (value === "Today") {
  //     newView = "timeGridDay";
  //     startDate = formatDate(today);
  //     endDate = startDate;
  //     // getCalenderData(startDate, endDate);

  //     if (calendarApi) {
  //       calendarApi.today(); // Jump to today's date
  //     }
  //   } else if (value === "Week") {
  //     newView = "timeGridWeek";

  //     const referenceDate = calendarApi?.view?.currentStart
  //       ? new Date(calendarApi.view.currentStart)
  //       : new Date();
  //     const startOfWeek = new Date(referenceDate);
  //     startOfWeek.setDate(referenceDate.getDate() - referenceDate.getDay());

  //     const endOfWeek = new Date(startOfWeek);
  //     endOfWeek.setDate(startOfWeek.getDate() + 6);

  //     startDate = formatDate(startOfWeek);
  //     endDate = formatDate(endOfWeek);
  //     setCalendarView(newView);
  //     setStartDate(startDate);
  //     setEndDate(endDate);
  //     // getCalenderData(startDate, endDate);

  //     if (calendarApi) {
  //       calendarApi.gotoDate(startOfWeek); // ✅ This aligns the visible week with the data range
  //     }
  //   } else if (value === "Month") {
  //     newView = "dayGridMonth";

  //     let referenceDate = today;

  //     if (calendarApi) {
  //       const view = calendarApi.view;
  //       if (view && view.currentStart) {
  //         referenceDate = new Date(view.currentStart);
  //       }
  //     }

  //     const startOfMonth = new Date(
  //       referenceDate.getFullYear(),
  //       referenceDate.getMonth(),
  //       1
  //     );
  //     const endOfMonth = new Date(
  //       referenceDate.getFullYear(),
  //       referenceDate.getMonth() + 1,
  //       0
  //     );

  //     startDate = formatDate(startOfMonth);
  //     endDate = formatDate(endOfMonth);
  //     // console.log("startDate, endDate", startDate, endDate)
  //     // console.log("startOfMonth, endOfMonth",  moment(startOfMonth).format('YYYY-MM-DD'), moment(endOfMonth).format('YYYY-MM-DD'))
  //     // getCalenderData(moment(startOfMonth).format('YYYY-MM-DD'), moment(endOfMonth).format('YYYY-MM-DD'));
  //     setCalendarView(newView);
  //     setStartDate(moment(startOfMonth).format("YYYY-MM-DD"));
  //     setEndDate(moment(endOfMonth).format("YYYY-MM-DD"));
  //   }

  //   if (calendarApi) {
  //     calendarApi.changeView(newView); // Set the new view type
  //   }
  // };

  const handleViewChange = (value) => {
    setSetsegmentState(value);

    if (!calendarApi) return;

    if (value === "Today") {
      calendarApi.changeView("timeGridDay");
      calendarApi.today(); // Jump to today
      return;
    }

    if (value === "Week") {
      calendarApi.changeView("timeGridWeek");
      return; // datesSetHandler will update start/end + title + view
    }

    if (value === "Month") {
      calendarApi.changeView("dayGridMonth");
      return;
    }
  };

  const getDayHeaderFormat = () => {
    // Apply custom formatting based on the view
    if (calendarView === "dayGridMonth") {
      return { weekday: "short" }; // Show only the weekday in Month view (e.g., "Mon")
    } else {
      return { weekday: "short", day: "numeric" }; // Show weekday and day number in Week view (e.g., "Mon 9")
    }
  };

  const showModal = (date = null) => {
    setPreselectedDate(date);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setPreselectedDate(null);
    // getCalenderData(startDate, endDate);
  };

  // const datesSetHandler = (info) => {
  //   const formattedStartDate = info.start.toISOString().split("T")[0];
  //   const formattedEndDate = info.end.toISOString().split("T")[0];

  //   setStartDate(formattedStartDate);
  //   setEndDate(formattedEndDate);
  // };
  const handleViewChangeNew = (view) => {
    setCalendarView(view);
    if (calendarApi) {
      calendarApi.changeView(view);
    }
  };
  const handlePrev = () => {
    if (calendarApi) {
      calendarApi.prev();
      updateDateRange(); // Fetch new data
    }
  };

  const handleNext = () => {
    if (calendarApi) {
      calendarApi.next();
      updateDateRange(); // Fetch new data
    }
  };
  const formatDateLocal = (date) => {
    return new Date(date).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };
  // ✅ Update Date Range & Fetch API
  const updateDateRange = () => {
    if (!calendarApi) return;

    const view = calendarApi.view;
    const start = view.currentStart;
    const end = view.currentEnd;
    // console.log("updateDateRange", { end})
    const newStartDate = formatDateLocal(start);
    const newEndDate = formatDateLocal(end);

    // setStartDate(newStartDate);
    // setEndDate(newEndDate);
    setCalendarTitle(view.title);
    console.log("updateDateRange", { newStartDate, newEndDate });
    // getCalenderData(newStartDate, newEndDate); // API call with formatted dates
  };

  const getCalenderMetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      // console.log("response>>>>>", data);

      if (data.code == 200) {
        setProgressStatus(data.data.progress_status);
        // setDisplayName(data.data.display_name)
        // setPriority(data.data.priority)
        setCalendarMetaData(data.data);
        setColorMetaData(data.data.colors);
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      // console.log("response>>>>>", data);
    } catch (error) {}
  };

  useEffect(() => {
    if (progressStatus.length > 0) {
      const params = new URLSearchParams(location.search);
      const statusParam = params.get("status"); // e.g. 'pending', 'completed'

      // console.log("dyamicFilter-progressStatus", { progressStatus, statusParam });

      const matchedStatus = progressStatus?.find(
        (item) => item.value === statusParam
      );

      if (matchedStatus) {
        applyFilters({
          status: matchedStatus.id,
          priorities: null,
          category: null,
          selectedUsers: [],
        });
      }
    }
  }, [location.search, progressStatus]);

  useEffect(() => {
    getCalenderMetaData();
  }, []);

  function getColorLabelById(id) {
    const color = colorMetaData.find((color) => color.id === id);
    return color;
  }

  function hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  useEffect(() => {
    if (ViewEventmodalOpen || ViewTaskmodalOpen) {
      const popover = document.querySelector(".fc-popover");
      if (popover) {
        popover.remove(); // closes the popover
      }
    }
  }, [ViewEventmodalOpen, ViewTaskmodalOpen]);

  const handleDateDoubleClick = (info) => {
    const now = new Date().getTime();
    const diff = now - lastClickTime;

    if (diff < 400) {
      // ✅ Double-click detected
      const clickedDate = moment(info.date).format("D MMMM YYYY");
      showModal(clickedDate); // <-- call your existing modal function
    }

    lastClickTime = now;
  };

  const showAddMemberModal = () => {
    setIsAddMemberModalOpen(true);
    // emailForm.resetFields();
  };

  const handleAddMember = async () => {
    setSubmitLoading(true);
    try {
      const values = await emailForm.validateFields();
      if (values) {
        let invitations = [
          {
            email: values.email,
            feature: "member",
            permission_id: null,
            children: null,
          },
        ];

        const response = await fetch(`${URL}/v1/invite/send`, {
          method: "POST",
          // headers: {
          //     "Content-Type": "application/json",
          //     Authorization: `Bearer ${token}`
          // },
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify({ invitations }), // Adjust role as needed
        });

        const data = await response.json();

        if (response.ok && data?.code == 200) {
          // setMembers([...members, { key: Date.now().toString() }]);
          setSubmitLoading(false);
          message.success("Invitation sent successfully!");
          setIsAddMemberModalOpen(false);
          setIsPopconfirmOpen(false);
        } else {
          setSubmitLoading(false);
          throw new Error(data?.message || "Failed to send invitation");
        }
      } else {
        setSubmitLoading(false);
        // console.log("Form validation failed:", values);
      }
    } catch (error) {
      setSubmitLoading(false);
      if (error.errorFields) {
        // Validation error, do nothing (antd will show the error)
        console.log("Validation error:", error.errorFields);
      } else {
        // Other errors (API, network, etc.)
        message.error(error.message);
      }
    }
  };

  return (
    <div>
      <div
        className={`calendar-container family-calendar ${
          calendarView === "timeGridWeek" ? "week-view" : ""
        } ${calendarView === "timeGridDay" ? "day-view" : ""}`}
      >
        <div className="calendar-header-wrapper">
          <div className="button-container">
            <Button
              className="white-bg"
              type="primary"
              icon={
                <img
                  src={fitericon}
                  alt="filter"
                  style={{ width: 16, height: 16 }}
                />
              }
              onClick={() => setIsFilterModalOpen(true)}
            >
              <span className="filter-text">Filter</span>
            </Button>
          </div>
          {/* Header Section */}
          <div className="calendar-header">
            <h2>Calendar</h2>
            <Segmented
              options={["Today", "Week", "Month"]}
              onChange={handleViewChange} // Function to change view
              defaultValue="Week" // Set the default view to "Week"
              className="custom-segmented"
            />
            <div className="calendar-actions">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => showModal()}
              >
                Add Task
              </Button>

              <Button
                className="members-add-btn-calendar mobile-only"
                type="primary"
                icon={<PlusOutlined />}
                onClick={showAddMemberModal}
              >
                Add Member
              </Button>
              {/* <span style={{ paddingLeft: '20px' }} ><SettingOutlined />  </span> */}
            </div>
          </div>
        </div>
        <div
          className="calenderhead2"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <div
            className="calenderheadlft"
            style={{ fontSize: "16px", fontWeight: "bold" }}
          >
            {calendarTitle}
          </div>
          <div className="calenderRgt">
            <Button
              className="calenderNext"
              shape="circle"
              icon={<LeftOutlined />}
              onClick={handlePrev}
            />
            <Button
              className="calenderPrev"
              shape="circle"
              icon={<RightOutlined />}
              onClick={handleNext}
            />
          </div>
        </div>

        {/* Calendar Component */}
        <div
          className={`calendar-scroll ${
            calendarView === "timeGridWeek" ? "week-scroll" : ""
          } ${calendarView === "timeGridDay" ? "day-scroll" : ""}`}
        >
          <FullCalendar
            height="auto"
            contentHeight="auto"
            expandRows={calendarView === "dayGridMonth"}
            aspectRatio={1.2}
            timeZone="UTC"
            slotMinTime="06:00:00"
            slotMaxTime="24:00:00"
            key={calendarView} // Ensures re-render when view changes
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView={calendarView}
            nowIndicator={true} // ✅ Shows the red current time line
            headerToolbar={false}
            firstDay={1}
            allDaySlot={false}
            dayHeaderFormat={{
              weekday: "short", // Sun, Mon, Tue
              day:
                calendarView === "timeGridWeek" ||
                calendarView === "timeGridDay"
                  ? "numeric"
                  : undefined,
            }}
            ref={(calendar) => {
              if (calendar) setCalendarApi(calendar.getApi());
            }}
            slotLabelFormat={{
              hour: "numeric",
              minute: "2-digit",
              // meridiem: "",
              hourCycle: "h23",
            }}
            eventContent={(eventInfo) => {
              const isWeekView = calendarView === "timeGridWeek";
              // Format time without the date
              const formattedStart = eventInfo.event.start
                ? moment.utc(eventInfo.event.start).format("HH:mm")
                : "";
              const formattedEnd = eventInfo.event.end
                ? moment.utc(eventInfo.event.end).format("HH:mm")
                : "";
              const fullTitle = eventInfo.event.title;
              // setsegmentState  = > "Today" "Month" "Week"
              let limitedTitle = fullTitle;

              if (setsegmentState === "Week") {
                limitedTitle =
                  fullTitle.length > 25
                    ? fullTitle.slice(0, 25) + "..."
                    : fullTitle;
              } else if (setsegmentState === "Month") {
                limitedTitle =
                  fullTitle.length > 20
                    ? fullTitle.slice(0, 20) + "..."
                    : fullTitle;
              }
              // console.log("eventInfoeventInfoeventInfo", eventInfo.event.extendedProps.color_id)
              return (
                // <div style={{ backgroundColor: getColorLabelById(eventInfo.event.extendedProps.color_id)?.value || "#f5f5f5" }}>
                <div>
                  <div>
                    <p className="calandarEventContent">
                      <p className="event-title">
                        <span className="event-time">
                          {formattedStart} - {formattedEnd}
                        </span>{" "}
                        <span
                          className="title-event"
                          style={{ fontWeight: "500" }}
                        >
                          {limitedTitle}
                        </span>
                      </p>
                    </p>
                  </div>
                </div>
              );
            }}
            eventDidMount={(info) => {
              const hexColor =
                getColorLabelById(info.event.extendedProps.color_id)?.value ||
                "#f5f5f5";

              const rgbaColor = hexToRgba(hexColor, 0.3); // Convert to rgba with 30% opacity

              info.el.style.setProperty(
                "background-color",
                rgbaColor,
                "important"
              );
              info.el.style.setProperty("border-color", rgbaColor, "important");
              info.el.style.setProperty("color", "#1D2433", "important");
            }}
            events={events.map((event) => ({
              ...event,
              backgroundColor: event.type == "task" ? "#F0F7FF" : "#FFEEEF", // ✅ Apply color directly
              borderColor: event.type == "task" ? "#F0F7FF" : "#FFEEEF", // Darker shade for border
            }))}
            eventClick={(eventInfo) => {
              if (eventInfo.event.extendedProps.type === "task") {
                // console.log("eventInfoeventInfoooo", eventInfo.event)
                handleTaskClick(eventInfo);
              } else {
                // console.log("eventInfo__handleEventClick",eventInfo)
                handleEventClick(eventInfo);
              }
            }}
            datesSet={datesSetHandler}
            dateClick={(info) => handleDateDoubleClick(info)}
            eventTextColor="#1D2433"
            dayMaxEvents={2}
            dayCellContent={(arg) => {
              const dateStr = arg.date.toISOString().split("T")[0];
              const count = events.filter(
                (e) => e.start.slice(0, 10) === dateStr
              ).length;

              return (
                <>
                  <div>{arg.dayNumberText}</div>
                  {/* {count > 0 && (
                    <div style={{ fontSize: '0.7rem', color: 'gray' }}>
                      {count} total
                    </div>
                  )} */}
                </>
              );
            }}
          />
        </div>
      </div>
      <div></div>
      <div>
        {isModalOpen && (
          <AddTask
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            getCalenderData={getCalenderData}
            CalenderStartDate={startDate}
            CalenderEndDate={endDate}
            defaultDate={preselectedDate}
          />
        )}

        {isFilterModalOpen && (
          <FilterModal
            isFilterModalOpen={isFilterModalOpen}
            closeFilterModal={() => setIsFilterModalOpen(false)}
            applyFilters={applyFilters}
            startDate={startDate}
            endDate={endDate}
            getCalenderData={getCalenderData}
            activeFilters={filters}
            calendarMetaData={calendarMetaData}
          />
        )}
      </div>
      <div>
        {ViewTaskmodalOpen && (
          <ViewTask
            isOpen={ViewTaskmodalOpen}
            onCancel={() => setViewTaskmodalOpen(false)}
            eventData={selectedEvent}
            onSuccess={() => getCalenderData(startDate, endDate)}
          />
        )}
      </div>
      <div>
        {ViewEventmodalOpen && (
          <ViewEvent
            isOpen={ViewEventmodalOpen}
            onCancel={() => setViewEventmodalOpen(false)}
            eventData={selectedEvent}
            onSuccess={() => getCalenderData(startDate, endDate)}
          />
        )}
      </div>
      <div className="">
        <Modal
          title="Add Member"
          style={{ opacity: isConfirmOpen ? 0.5 : 1 }}
          open={isAddMemberModalOpen}
          onCancel={() => {
            setIsAddMemberModalOpen(false);
          }}
          onOk={!isConfirmOpen ? handleAddMember : undefined}
          width={500}
          closable={false}
          maskClosable={false}
          className="addMemberModal"
          footer={[
            <Popconfirm
              classNames="member-cancel-confirmation"
              key="cancel"
              title="Are you sure you want to cancel? Unsaved changes will be lost."
              okText="Yes"
              cancelText="No"
              zIndex={2001}
              open={isPopconfirmOpen}
              onConfirm={() => {
                setIsConfimOpen(false);
                setIsPopconfirmOpen(false);
                setTimeout(() => {
                  setIsAddMemberModalOpen(false);
                }, 0);
              }}
              cancelButtonProps={{ danger: true }}
              okButtonProps={{ danger: false }}
              onCancel={() => {
                setIsPopconfirmOpen(false);
                setIsConfimOpen(false);
              }}
            >
              <Button
                disabled={isConfirmOpen}
                onClick={() => {
                  setIsPopconfirmOpen(true);
                  setIsConfimOpen(true);
                }}
              >
                Cancel
              </Button>
            </Popconfirm>,
            <Button
              key="ok"
              type="primary"
              loading={submitLoading}
              disabled={submitLoading || isConfirmOpen}
              onClick={handleAddMember}
            >
              OK
            </Button>,
          ]}
        >
          <Form form={emailForm} layout="vertical">
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Please enter a valid email",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};
export default Calender;
